import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { listItemStyle, textFieldStyle } from '../../../utils/consts/styles';
import { EDUCATION_TYPE_LIST } from '../../../utils/consts/educationType';

// Смена типа обучения в карточке слушателя. После сохранения карточка
// переоткрывается по разделу нового типа (см. changeStudentData).
export default function EducationTypeSelect({ defaultValue = '', disabled = false }) {
  return (
    <TextField label="Тип обучения" name="education_type" type="text" variant="outlined"
      color="error" margin="normal" defaultValue={defaultValue}
      required size="small" select focused InputLabelProps={textFieldStyle}
      disabled={disabled}>
      {EDUCATION_TYPE_LIST.map((type) => (
        <MenuItem key={type} value={type}>
          <span style={listItemStyle}>{type}</span>
        </MenuItem>
      ))}
    </TextField>
  );
}
